import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonSharedComponent } from './button.component';
import { FaIconSharedModule } from '../fa.icon/fa.icon.module';

@NgModule({
    declarations: [
        ButtonSharedComponent
    ],
    imports: [
        CommonModule,
        FaIconSharedModule
    ],
    exports: [
        ButtonSharedComponent
    ]
})

export class ButtonSharedModule {}
